// extracted by mini-css-extract-plugin
export default {"root":"bs5NG20p"};